module.exports = __webpack_public_path__ + "static/img/qywx.c204b9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qywx.png
// module id = iy+j
// module chunks = 1